import {useEffect, useLayoutEffect, useRef} from "react";

import {useSelector} from "react-redux";
import {useTimer} from "react-timer-hook";

/** @param {number | null | undefined} durationMs — session length in ms (API seconds × 1000) */
export const useChatTime = (durationMs) => {
  const hasDuration = Number.isFinite(durationMs) && durationMs > 0;

  const {totalSeconds, start, restart} = useTimer({
    expiryTimestamp: new Date(),
    autoStart: false,
    onExpire: () => console.warn("onExpire called"),
  });

  const {messages} = useSelector((state) => state.ml.chat);
  const hasStartedRef = useRef(false);

  useLayoutEffect(() => {
    if (!hasDuration) {
      hasStartedRef.current = false;
      restart(new Date(), false);
      return;
    }
    restart(new Date(Date.now() + durationMs), false);
  }, [durationMs, hasDuration, restart]);

  useEffect(() => {
    if (!hasDuration) return;
    if (messages.length === 0) {
      hasStartedRef.current = false;
      return;
    }
    if (!hasStartedRef.current) {
      start();
      hasStartedRef.current = true;
    }
  }, [hasDuration, messages.length, start]);

  const chatTime = hasDuration ? totalSeconds * 1000 : null;

  if (!hasDuration) {
    return [null, () => {}, restart];
  }

  return [chatTime, () => {}, restart];
};
